import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { SchoolService } from '../../../../../services/school.service';
import { ClassService } from '../../../../../services/class.service';
import { StudentService } from '../../../../../services/student.service';
import { SystemService } from '../../../../../services/system.service';
import { SCHOOL_TYPE, UserType } from '../../../../../model/Const';
import { PreviousRouteService } from '../../../../../services/previous-route.service';


@Component({
    selector: 'app-class-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class StudentsIndexComponent implements OnInit {
  displayData: any[] = [];
  totalClasses = 0;
  currentPageIndex = 1;
  classId = 0;
  className = '';
  classComment = '';
  errStudentDataVisible = false;
  errStus = [];
  showBatchAddBtn = false;

  disabledButton = true;
  allChecked = false;
  indeterminate = false;
  checkedNumber = 0;

  classChangeVisible = false;
  isLoadingTeacherCLass = false;
  displayLexileModal = false;

  teacherList: any[] = [];
  classList: any[] = [];
  teacherCache = {};
  classCache = {};

  selectedTeacher: any = null;
  selectedClass: any = null;
  adjustReportData = false;
  syncHomework = false;
  activeHomeworks: any[] = [];
  selectedHomeworkIds: number[] = [];
  isLoadingHomeworks = false;
  confirmChangeVisible = false;
  schoolMaster = false;
  schoolType = 0;
  schoolId = 0;

  PAYG_TYPE = SCHOOL_TYPE.PAYG;
  returnPage = 1;
  isAccountManager = false;

  deleteStudentConfirm: NzModalRef|null = null;

  delStudent: any = null;

  changeClassText = '';
  teacher = '';
  openclassing = false;
  loadingData = false;



  accountInfoSuccess = false;
  accountInfoError = false;
  accountInfo: any[]|null = null;
  accountDaysType = null;
  accountDaysTypeRemainCount = 0;
  openUserId = null;
  changeClassButtonLoading = false;


  lexileAccountNumber = 0;

  // 蓝思开放弹窗相关变量
  displayOpenLexileModal = false;
  openLexileUserId: number | string | null = null;
  openLexileStartDate: Date | null = null;
  openLexileEndDate: Date | null = null;
  openLexileLoading = false;

  // 蓝思关闭弹窗相关变量
  displayCloseLexileModal = false;
  closeLexileUserId: number | string | null = null;
  closeLexilePermissionId: number | string | null = null;
  closeLexileLoading = false;

  // 是否可以管理蓝思开放/关闭权限（仅 TEACHER 和 SCHOOL_ADMIN）
  canManageLexilePermission = false;

  // @ViewChild('accountInfoSuccessTpl', {static: true})
  // accountInfoSuccessTpl: TemplateRef<{}>;
  private isSA = false;


  constructor(private schoolService: SchoolService,
              private modalService: NzModalService,
              private userService: UserService,
              private prService: PreviousRouteService,
              private stuService: StudentService,
              private clsService: ClassService,
              private activatedRoute: ActivatedRoute ,
              private router: Router ,
              private sysSrv: SystemService,
              private nzMessageService: NzMessageService) {
    const user = this.userService.getUserInfo();
    console.log(user);
    this.schoolMaster = user.type === UserType.SCHOOL_ADMIN;
    this.schoolType = user.school_type;
    this.schoolId = user.school_id;
    this.activatedRoute.params.subscribe( params => {
      if (params['class_id'] && parseInt(params['class_id'], 10) === params['class_id'] * 1) {
        this.classId = parseInt(params['class_id'], 10);
      }
    });
    this.activatedRoute.queryParams.subscribe( query => {
      if (query['page'] && parseInt(query['page'], 10) === query['page'] * 1) {
        this.returnPage = parseInt(query['page'], 10);
      }
    });

    this.isAccountManager = user.isAccountManager
      || user.type === UserType.SCHOOL_ADMIN ;
    this.isSA = user.type === UserType.SUPER_ADMIN;
    this.canManageLexilePermission = user.type === UserType.TEACHER || user.type === UserType.SCHOOL_ADMIN;
  }

  ngOnInit() {
    this.loadData(this.currentPageIndex);
    this.loadClassData();
  }
  loadData(page: string|number) {
    this.loadingData = true;
    this.stuService.fetchStudentsBySchoolId(page, null, this.schoolId, this.classId).then(classes => {
    // this.stuService.fetchStudentsByClassId(this.classId, page).then(classes => {
      console.log(classes.rows);
      this.displayData = classes.rows;
      this.totalClasses = classes.total;
      // this.className = classes.class_name;
      this.classComment = classes.class_comment;
      // @ts-ignore
      this.currentPageIndex = page;
      this.refreshStatus();
      this.loadingData = false;
      // this.setTmpNumId();
      console.log('classes:', classes);
    }).catch(err => {
      this.loadingData = false;
      this.nzMessageService.error(`错误：${err.message}`);
    });
  }
  setTmpNumId() {
    for (let i = 0; i < this.displayData.length; i++) {
      // @ts-ignore
      this.displayData[i].numId = i + 1 + (this.currentPageIndex - 1) * 10;
    }
  }
  loadClassData() {
    const srv = this.clsService;
    srv.fetchClassAndTeacher(this.classId).then(data => {
      this.className = data[0].class_name;
      this.teacher = data[0].teacher;
    });
  }
  closeDeleteStudentConfirm() {
    this.delStudent = null;
    // this.deleteStudentConfirm = false;
  }
  sureDeleteStudentConfirm() {
    if (!this.delStudent) {
      return;
    }
    this.loadingData = true;
    this.userService.unbindClassStudent(this.classId, this.delStudent.user_id).then(classes => {
      this.loadData(this.currentPageIndex);
      // this.currentPageIndex = 1;
      // this.deleteStudentConfirm = false;
    }).catch(e => {
      this.loadingData = false;
      // this.deleteStudentConfirm = false;
      this.nzMessageService.error(e.message);
    });
    this.delStudent = null;
  }
  deleteStudentReConfirm(row: any) {
    this.delStudent = row;
    this.deleteStudentConfirm = this.modalService.confirm({
      nzTitle: '确定将学生移除该班级吗？',
      nzContent: '<b style="color: red;">确认移除吗？？？</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.sureDeleteStudentConfirm(),
      nzCancelText: 'No',
      // nzOnCancel: () => console.log('Cancel')
    });
  }
  deleteStudents() {
    // @ts-ignore
    const ids = this.displayData.filter(value => value.checked).map( u => u.id);
    this.userService.removeStudents(this.classId, ids).then(classes => {
      this.loadData(this.currentPageIndex);
      // this.currentPageIndex = 1;
    });
  }
  handleCancelOpenAccountDialog () {
    this.openUserId = null;
    this.accountInfoSuccess = false;
  }
  handleOpenAccount () {
    if (this.loadingData) {
      return;
    }
    this.loadingData = true;
    this.accountInfoSuccess = false;

    // @ts-ignore
    this.userService.grantUser(this.openUserId, this.accountDaysType).then(data => {
      this.loadData(this.currentPageIndex );
    }).catch(err => {
      this.loadingData = false;
      this.nzMessageService.error(err.message);
    });

  }

  grantLexileUser(id: number|string) {
    // @ts-ignore
    this.openUserId = id;
    this.displayLexileModal = true;

    this.schoolService.getRemainLexileAccountInfo().then( num => {
      console.log(num);
      this.lexileAccountNumber = num.total_quantity;
      this.loadingData = false;
    }).catch(err => {
      this.loadingData = false;
      this.nzMessageService.error(err.message);
    });


  }

  handleGrantLexileAccount () {
    if (this.loadingData) {
      return;
    }
    this.loadingData = true;
    this.displayLexileModal = false;
    // @ts-ignore
    this.userService.grantUserLexile(this.openUserId).then(data => {
      this.loadData(this.currentPageIndex );
    }).catch(err => {
      this.loadingData = false;
      this.nzMessageService.error(err.message);
    });

  }

  // 打开蓝思开放弹窗
  openLexileUser(userId: number | string) {
    this.openLexileUserId = userId;
    this.openLexileStartDate = null;
    this.openLexileEndDate = null;
    this.displayOpenLexileModal = true;
  }

  // 关闭蓝思开放弹窗
  handleCancelOpenLexileModal() {
    this.displayOpenLexileModal = false;
    this.openLexileUserId = null;
    this.openLexileStartDate = null;
    this.openLexileEndDate = null;
  }

  // 格式化日期为 YYYY-MM-DD 格式
  private formatDateToString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // 确认开放蓝思权限
  handleOpenLexilePermission() {
    if (!this.openLexileStartDate || !this.openLexileEndDate) {
      this.nzMessageService.warning('请选择开始日期和结束日期');
      return;
    }

    if (this.openLexileStartDate > this.openLexileEndDate) {
      this.nzMessageService.warning('开始日期不能晚于结束日期');
      return;
    }

    const today = new Date();
    // 设置当前日期的时间为 00:00:00
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(this.openLexileEndDate);
    endDate.setHours(0, 0, 0, 0);

    if (endDate < today) {
      this.nzMessageService.warning('结束日期必须大于等于当前日期');
      return;
    }

    if (this.openLexileLoading) {
      return;
    }

    this.openLexileLoading = true;

    const startDateStr = this.formatDateToString(this.openLexileStartDate);
    const endDateStr = this.formatDateToString(this.openLexileEndDate);

    // @ts-ignore
    this.userService.openLexileExamPermission(this.openLexileUserId, startDateStr, endDateStr).then(data => {
      this.nzMessageService.success('蓝思开放成功');
      this.displayOpenLexileModal = false;
      this.openLexileLoading = false;
      this.loadData(this.currentPageIndex);
    }).catch(err => {
      this.openLexileLoading = false;
      this.nzMessageService.error(err.message);
    });
  }

  // 打开蓝思关闭弹窗
  closeLexileUser(userId: number | string, permissionId: number | string) {
    this.closeLexileUserId = userId;
    this.closeLexilePermissionId = permissionId;
    this.displayCloseLexileModal = true;
  }

  // 取消关闭蓝思弹窗
  handleCancelCloseLexileModal() {
    this.displayCloseLexileModal = false;
    this.closeLexileUserId = null;
    this.closeLexilePermissionId = null;
  }

  // 确认关闭蓝思权限
  handleCloseLexilePermission() {
    if (this.closeLexileLoading) {
      return;
    }

    this.closeLexileLoading = true;

    // @ts-ignore
    this.userService.closeLexileExamPermission(this.closeLexileUserId, this.closeLexilePermissionId).then(data => {
      this.nzMessageService.success('蓝思权限已关闭');
      this.displayCloseLexileModal = false;
      this.closeLexileLoading = false;
      this.loadData(this.currentPageIndex);
    }).catch(err => {
      this.closeLexileLoading = false;
      this.nzMessageService.error(err.message);
    });
  }


  grantUser(id: number|string) {
    // @ts-ignore
    this.openUserId = id;
    this.accountInfoSuccess = true;
    this.schoolService.getRemainAccountInfo().then( info => {
      console.log(info);
      this.accountInfo = info;
      if (info.length) {
        this.accountDaysType = info[0].days;
        this.accountDaysTypeRemainCount = info[0].count;
      }
      this.loadingData = false;
    }).catch(err => {
      this.loadingData = false;
      this.nzMessageService.error(err.message);
    });


  }
  grantAllStudentsInClass () {
    this.openclassing = true;
    this.userService.grantClass(this.classId).then(data => {
      this.loadData(this.currentPageIndex );
      this.openclassing = false;
    }).catch(err => {
      this.nzMessageService.error(err.message);
      this.openclassing = false;
    });
  }
  editStudent(id: string|number) {
    this.router.navigate([`/admin/classes/${this.classId}/students/edit/${id}`]);
  }

  batchAddStudents = (file: File) => {
    const data = new FormData();
    data.append('file', file);
    this.userService.batchAddUsers(this.classId , data).then(r => {
      console.log(r);
      this.errStus = r;
      this.errStudentDataVisible = true;
    });
    return false;
  }
  handleErrStuCancel() {
    this.loadData(1);
    this.errStudentDataVisible = false;
  }
  handleErrStuOk()  {
    this.loadData(1);
    this.errStudentDataVisible = false;
  }

  checkAll(value: boolean): void {
    // @ts-ignore
    this.displayData.forEach(data => data.checked = value);
    this.refreshStatus();
  }
  refreshStatus(): void {
    // @ts-ignore
    const allChecked = this.displayData.every((value: any) => value.checked === true);
    // @ts-ignore
    const allUnChecked = this.displayData.every((value: any) => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
    // @ts-ignore
    this.disabledButton = !this.displayData.some((value: any) => value.checked);
    // @ts-ignore
    this.checkedNumber = this.displayData.filter((value: any) => value.checked).length;
  }
  changeStudentClass() {
    if (this.checkedNumber > 0) {
      if (Object.keys(this.teacherCache).length && Object.keys(this.classCache).length) {
        this.classChangeVisible = true;
        return;
      }
      this.isLoadingTeacherCLass = true;
      const info = this.userService.getUserInfo();
      this.sysSrv.loadTeacherAndClasses(info.school_id).then(result => {
        this.classChangeVisible = true;

        console.log('result:', result);
        // @ts-ignore
        this.teacherCache[info.school_id] = result.teachers;
        for (const k of Object.keys(result.teachers)) {
          const t = result.teachers[k];
          // @ts-ignore
          if (this.classCache[t.teacher_id]) {
            // @ts-ignore
            this.classCache[t.teacher_id] = [...this.classCache[t.teacher_id], ...result.classes[t.teacher_id]];
          } else {
            // @ts-ignore
            this.classCache[t.teacher_id] = result.classes[t.teacher_id] ? result.classes[t.teacher_id] : [] ;
          }
        }
        this.teacherList = Object.values(result.teachers) as any[];

        this.isLoadingTeacherCLass = false;
      });
    } else {
      this.nzMessageService.error('请先勾选需要调整的学生');
    }
  }
  closeChangeStudentClass() {
    this.classChangeVisible = false;
    this.isLoadingTeacherCLass = false;
    this.adjustReportData = false;
    this.resetHomeworkSelection();
  }
  doSelectTeacher(teacher: any) {
    this.selectedTeacher = teacher;
    this.classList = [];
    this.selectedClass = null;
    this.resetHomeworkSelection();
    if (!teacher) {
      return;
    }
    // @ts-ignore
    if (this.classCache[teacher.teacher_id]) {
      // @ts-ignore
      this.classList = this.classCache[teacher.teacher_id].filter(c => {
        return +c.id !== +this.classId;
      });
    } else {
      alert('no classes for this teacher');
    }
  }
  onTargetClassChange(selectedClass: any) {
    this.selectedClass = selectedClass;
    this.resetHomeworkSelection();
  }
  onSyncHomeworkChange(checked: boolean) {
    if (!checked || !this.selectedClass) {
      this.resetHomeworkSelection();
      return;
    }

    const classId = Number(this.selectedClass.id);
    this.isLoadingHomeworks = true;
    this.userService.fetchActiveClassHomeworks(classId).then(list => {
      if (this.syncHomework && Number(this.selectedClass?.id) === classId) {
        this.activeHomeworks = list || [];
      }
    }).catch(() => {
      if (Number(this.selectedClass?.id) === classId) {
        this.nzMessageService.error('获取未过期作业失败');
        this.resetHomeworkSelection();
      }
    }).finally(() => {
      if (Number(this.selectedClass?.id) === classId) {
        this.isLoadingHomeworks = false;
      }
    });
  }
  toggleHomework(homeworkId: number, checked: boolean) {
    if (checked) {
      this.selectedHomeworkIds = Array.from(new Set([...this.selectedHomeworkIds, homeworkId]));
    } else {
      this.selectedHomeworkIds = this.selectedHomeworkIds.filter(id => id !== homeworkId);
    }
  }
  private resetHomeworkSelection() {
    this.syncHomework = false;
    this.activeHomeworks = [];
    this.selectedHomeworkIds = [];
    this.isLoadingHomeworks = false;
  }
  setChangeClassText() {
      let str = '将 ';
      let len = 0;
      for (let i = 0; i <  this.displayData.length; i++) {
        // @ts-ignore
          if (this.displayData[i].checked) {
              len ++ ;
            // @ts-ignore
              str += (this.displayData[i].name || this.displayData[i].user_name) + ' 、';
          }
      }
      str = str.substr(0, str.length - 1);
    // @ts-ignore
      str += `移动到 ${this.selectedTeacher.name} 老师的 ${this.selectedClass.name} 吗？`;
      this.changeClassText = str;
  }
  handleChangeOk() {
    if (!this.selectedTeacher || !this.selectedClass) {
      this.nzMessageService.error('请正确选择教师和班级');
      return;
    }
    this.confirmChangeVisible = true;
    this.changeClassButtonLoading = false;
    this.setChangeClassText();
    this.modalService.confirm({
      nzTitle: '调整班级',
      nzContent: `<b style="color: red;">${this.changeClassText}</b>`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.sureConfirm(),
      nzCancelText: 'No',
    });
  }
  closeConfirm() {
    this.confirmChangeVisible = false;
  }
  sureConfirm() {
    console.log('in sureConfirm');
    // this.changeClassButtonLoading = true;
    this.loadingData = true;

    this.confirmChangeVisible = false;
    this.classChangeVisible = false;
    this.changeClassButtonLoading = false;
// @ts-ignore
    const selectedStudents = this.displayData.filter(value => value.checked);
    const uids = selectedStudents.map(r => {
      return {
        user_id: r.user_id,
        class_id: r.class_id,
        school_id: r.school_id,
        row_id: r.class_user_row_id
      };
    });
    console.log(this.selectedClass);
    console.log(uids);
    const targetClassId = this.selectedClass.id;
    const homeworkIds = [...this.selectedHomeworkIds];
    const shouldPushHomework = this.syncHomework && homeworkIds.length > 0;
    // @ts-ignore
    this.stuService.changeClass(targetClassId, uids, this.adjustReportData).then(r => {
      if (!shouldPushHomework) {
        return null;
      }
      return this.userService.sendHomeworksToStudent({
        class_id: targetClassId,
        user_ids: selectedStudents.map(student => student.user_id),
        homework_ids: homeworkIds,
      }).catch(err => {
        this.nzMessageService.error(`调整班级成功，作业推送失败：${err.message}`);
        return null;
      });
    }).then(() => {
      this.loadData(this.currentPageIndex);
      this.confirmChangeVisible = false;
      this.classChangeVisible = false;
      this.changeClassButtonLoading = false;
      this.resetHomeworkSelection();
    }).catch(e => {
      this.loadingData = false;
      this.nzMessageService.error(e.message);
    });
  }
  goBack() {
    const prevUrl = this.prService.getPreviousUrl();
    if (prevUrl) {
      this.router.navigate([prevUrl]);
    } else {
      history.go(-1);
    }
  }
  createConfirmCheckModal(title = '提示', rejectContent: string, data?: {}, okCb?: Function, errCb?: Function): NzModalRef {
    const self = this;
    const modal = this.modalService.create({
      nzTitle: title,
      nzContent: rejectContent,
      nzData: data,
      nzMaskClosable: false,
      nzClosable: false,
      nzFooter: [
        {
          label: '关闭',
          type: 'default',
          loading: false,
          onClick(): void {
            if (errCb) {
              errCb();
            }
            modal.destroy();
          }
        },
        {
          label: '确定',
          type: 'primary',
          loading: false,
          onClick(): void {
            // console.log(modal);
            // const m = modal.getInstance();
            // m.nzFooter[0].disabled = true;
            // this.loading = true;
            /*
            self.orderService.changeSubsidyStatus(data).then(resp => {
              this.loading = false;
              self.modalService.closeAll();
              self.loadData(self.currentPageIndex);
              modal.destroy();
            }).catch(err => {
              this.nzMessageService.error(err.message);
              this.loading = false;
            });*/
            if (okCb) {
              okCb(modal);
            }

          }
        },
      ]
    });
    return modal;
  }
  changeOpenStudentAccount(evt: any) {
    // @ts-ignore
    for (const at of this.accountInfo) {
      if (at.days === evt) {
        this.accountDaysTypeRemainCount = at.count;
      }
    }
  }
}
